import { Route } from 'react-router-dom';
import Articles from '../pages/articles';
import ProductDetails from '../pages/articles/product-details';
import AddProduct from '../pages/articles/add-product';
import Commandes from '../pages/commandes';
import Customers from '../pages/customers';
import CustomerInvoices from '../pages/customers/invoices';
import Personnel from '../pages/personnel';
import DossierPersonnel from '../pages/personnel/dossier';
import PaieMois from '../pages/personnel/paie';
import BulletinPaie from '../pages/personnel/bulletin';
import ReglagesPaie from '../pages/personnel/reglages';
import Suppliers from '../pages/suppliers';
import SupplierArticles from '../pages/suppliers/articles';
import Stores from '../pages/stores';
import Category from '../pages/categories';
import SubCategories from '../pages/sub-categories';
import Units from '../pages/units';
import Warehouses from '../pages/warehouses';
import Supply from '../pages/supply';
import AddSupply from '../pages/supply/add-supply';
import UpdateSupply from '../pages/supply/update-supply';
import Brands from '../pages/admin/brands';
import RolesPermissions from '../pages/roles-permissions';
import Formats from '../pages/formats';
import AdminOrdersList from '../pages/admin/orders';
import AdminSummary from '../pages/admin/summary';
import StockAdjustments from '../pages/stock-adjustments';
import InstallmentOrder from '../pages/installment-order';
import InstallmentInvoice from '../pages/installment-order/invoice';
import AdminStock from '../pages/admin/stock';
import BestSelling from '../pages/admin/best-selling';
import BrokenTilesList from '../pages/admin/broken-tiles';
import AddBrokenTile from '../pages/admin/broken-tiles/create';
import SalesBrokenTiles from '../pages/admin/broken-tiles/sales';
import BrokenTileSalesList from '../pages/admin/broken-tiles/list-sale';
import ValidateBrokenTiles from '../pages/admin/broken-tiles/validate';
import DamagedGoodsList from '../pages/admin/damaged-goods';
import AddDamagedGood from '../pages/admin/damaged-goods/create';
import SalesDamagedGoods from '../pages/admin/damaged-goods/sales';
import DamagedGoodSalesList from '../pages/admin/damaged-goods/list-sale';
import ValidateDamagedGood from '../pages/admin/damaged-goods/validate';
import DonationsList from '../pages/admin/donations';
import AddDonation from '../pages/admin/donations/create';
import Comptable from '../pages/comptable';
import ComptableInventoryPage from '../pages/comptable/inventory';
import ComptableSalesPage from '../pages/comptable/sales';
import MagasinierValidation from '../pages/magasinier';
import MagasinierUpdateInvoice from '../pages/magasinier/update-invoice';
import MagasinierHistory from '../pages/magasinier/history';
import MagasinierSummary from '../pages/magasinier/summary';
import OrderValidation from '../pages/commandes/validate';
const GRANTED = [
  { url: '/clients', path: '/clients', element: <Customers /> },
  { url: '/clients', path: '/clients/:customerId/factures', element: <CustomerInvoices /> },
  { url: '/admin/ventes', path: '/admin/ventes', element: <AdminOrdersList /> },
  { url: '/commandes', path: '/commandes', element: <Commandes /> },
  { url: '/approvisionnement', path: '/approvisionnement', element: <Supply /> },
  { url: '/approvisionnement', path: '/add-supply', element: <AddSupply /> },
  { url: '/approvisionnement', path: '/update-supply/:itemId', element: <UpdateSupply /> },
  { url: '/admin/installment-orders', path: '/admin/installment-orders', element: <InstallmentOrder /> },
  { url: '/admin/installment-orders', path: '/admin/installment-orders/:id', element: <InstallmentInvoice /> },
  { url: '/articles', path: '/articles', element: <Articles /> },
  { url: '/articles', path: '/product-details/:id', element: <ProductDetails /> },
  { url: '/articles', path: '/add-product', element: <AddProduct /> },
  { url: '/categories', path: '/categories', element: <Category /> },
  { url: '/sub-categories', path: '/sub-categories', element: <SubCategories /> },
  { url: '/marques', path: '/marques', element: <Brands /> },
  { url: '/units', path: '/units', element: <Units /> },
  { url: '/formats', path: '/formats', element: <Formats /> },
  { url: '/fournisseurs', path: '/fournisseurs', element: <Suppliers /> },
  { url: '/fournisseurs', path: '/fournisseurs/articles', element: <SupplierArticles /> },
  { url: '/admin/summary', path: '/admin/summary', element: <AdminSummary /> },
  { url: '/admin/stock-adjustments', path: '/admin/stock-adjustments', element: <StockAdjustments /> },
  { url: '/admin/broken-tiles', path: '/admin/broken-tiles', element: <BrokenTilesList /> },
  { url: '/admin/broken-tiles', path: '/admin/broken-tiles/create', element: <AddBrokenTile /> },
  { url: '/admin/broken-tiles', path: '/broken-tiles/validate/:ref', element: <ValidateBrokenTiles /> },
  { url: '/admin/sales-broken-tiles/list', path: '/admin/sales-broken-tiles/list', element: <BrokenTileSalesList /> },
  { url: '/admin/sales-broken-tiles/list', path: '/admin/sales-broken-tiles', element: <SalesBrokenTiles /> },
  { url: '/admin/damaged-goods', path: '/admin/damaged-goods', element: <DamagedGoodsList /> },
  { url: '/admin/damaged-goods', path: '/admin/damaged-goods/create', element: <AddDamagedGood /> },
  { url: '/admin/damaged-goods', path: '/admin/damaged-goods/validate/:ref', element: <ValidateDamagedGood /> },
  { url: '/admin/damaged-goods/sales/list', path: '/admin/damaged-goods/sales/list', element: <DamagedGoodSalesList /> },
  { url: '/admin/damaged-goods/sales/list', path: '/admin/damaged-goods/sales', element: <SalesDamagedGoods /> },
  { url: '/admin/dons', path: '/admin/dons', element: <DonationsList /> },
  { url: '/admin/dons', path: '/admin/dons/nouveau', element: <AddDonation /> },
  { url: '/best-selling', path: '/best-selling', element: <BestSelling /> },
  { url: '/personnel', path: '/personnel', element: <Personnel /> },
  { url: '/personnel', path: '/personnel/:id/dossier', element: <DossierPersonnel /> },
  { url: '/personnel/paie', path: '/personnel/paie', element: <PaieMois /> },
  { url: '/personnel/paie', path: '/personnel/paie/:personnelId', element: <BulletinPaie /> },
  { url: '/personnel/paie/reglages', path: '/personnel/paie/reglages', element: <ReglagesPaie /> },
  { url: '/roles-permissions', path: '/roles-permissions', element: <RolesPermissions /> },
  { url: '/stores', path: '/stores', element: <Stores /> },
  { url: '/warehouses', path: '/warehouses', element: <Warehouses /> },
  { url: '/stock-available', path: '/stock-available', element: <AdminStock /> },
  { url: '/comptable', path: '/comptable', element: <Comptable /> },
  { url: '/inventory', path: '/inventory', element: <ComptableInventoryPage /> },
  { url: '/sales', path: '/sales', element: <ComptableSalesPage /> },
  { url: '/livraisons', path: '/livraisons', element: <MagasinierValidation /> },
  { url: '/livraisons', path: '/commande/:reference', element: <MagasinierUpdateInvoice /> },
  { url: '/commandes/history', path: '/commandes/history', element: <MagasinierHistory /> },
  { url: '/summary', path: '/summary', element: <MagasinierSummary /> },
  { url: '/commandes/validation', path: '/commandes/validation', element: <OrderValidation /> },
];

export function renderGrantedRoutes(pages) {
  const allowed = new Set(pages || []);
  return GRANTED
    .filter((route) => allowed.has(route.url))
    .map((route) => <Route key={route.path} path={route.path} element={route.element} />);
}
